<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Ingreso Administrativo - Ver</strong>

            <router-link  class="btn btn-light float-right btn-sm"  :to="{ path: '/ingreso-administrativo/listar' }" append ><i class="fa fa-chevron-left"></i> Regresar</router-link>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" autocomplete="off">
              <b-row>

                <b-col md="4">
                  <b-form-group>
                    <label>Cliente:</label>
                    <v-select placeholder="Seleccione un cliente" class="w-100" :filterable="false" label="text" v-model="client" disabled></v-select>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Código:">
                    <b-form-input type="text" disabled  class="text-center" v-model="income.code"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Tipo:">
                    <b-form-select disabled v-model="income.id_income_method" :options="income_method"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Fecha:">
                    <b-form-input disabled type="date" class="text-center" :min="income.now_date" v-model="income.date"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Metodo de Pago:">
                    <b-form-select disabled v-model="income.payment_method" :options="payment_method"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="10">
                  <b-form-group label="Observación:">
                    <b-form-textarea disabled v-model="income.observation"></b-form-textarea>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Total:">
                    <b-form-input disabled type="number" step="any" class="text-right" v-model="income.total"></b-form-input>
                  </b-form-group>
                </b-col>
 
                <b-col md="5"></b-col>
                <b-col md="2">
                  <b-button class="form-control" @click="OpenVoucher" type="button" variant="warning">Imprimir Recibo</b-button>
                </b-col>
                
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <ModalClients />
    <LoadingComponent :is-visible="isLoading"/>
  </div>
</template>

<script>

import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";


const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
var moment = require("moment");

import { mapState,mapMutations,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
import DataCollection from "@/assets/js/DataCollection";
// components
import ModalClients from './../components/ModalClient'
import LoadingComponent from './../pages/Loading'
export default {
  name: "UsuarioAdd",
  props: ["id_income"],
  components:{
      vSelect,
      ModalClients,
      Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'Income',
      role: 5,
      income: {
        id_income:'',
        id_user:'',
        id_client:'',
        id_branch_office:'',
        id_income_method:'',
        code:'',
        payment_method:'008',
        date:moment(new Date()).local().format("YYYY-MM-DD"),
        now_date: moment(new Date()).local().format("YYYY-MM-DD"),
        observation:'',
        total:'',
        state:'',
      },
      // payment_method:[
      //   {value:'008', text:'EFECTIVO'},
      //   {value:'007', text:'CHEQUES'},
      //   {value:'001', text:'DEPÓSITO EN CUENTA'},
      //   {value:'003', text:'TRANSFERENCIA DE FONDOS'},
      // ],
      client: null,
      clients: [],
      income_method:[],
      errors: {
        id_client: false,
        code: false,
        payment_method: false,
        date: false,
        total: false,
      },
      validate: false,
    };
  },
  mounted() {
    this.ListIncomeMethod();
    this.ViewIncome();
  },
  methods: {
    ListIncomeMethod,
    ViewIncome,
    OpenVoucher,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
    payment_method: function () {
      return DataCollection.MethodPayment();
    }
  },
};

function ViewIncome() {
  let me = this;
  let id_income = je.decrypt(this.id_income);
  let url = me.url_base + "income/view/"+id_income;
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.income.id_income = response.data.result.id_income;
        me.income.id_client = response.data.result.id_client;
        me.income.id_user = response.data.result.id_user;
        me.income.id_branch_office = response.data.result.id_branch_office;
        me.income.id_income_method = response.data.result.id_income_method;
        me.income.code = response.data.result.code;
        me.income.payment_method = response.data.result.payment_method;
        me.income.date = response.data.result.date;
        me.income.observation = response.data.result.observation;
        me.income.total = response.data.result.total;
        me.income.state = response.data.result.state;
        me.client = { value: response.data.result.id_client, text: response.data.result.client_name+' | '+  response.data.result.credit_code}
      }
    });
}

function ListIncomeMethod() {
  let me = this;
  let url = me.url_base + "income/list-incomes-method";
  me.income_method = [{ value: '', text:'- Seleccione una opcion - '}];
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      response.data.result.forEach(element => {
        me.income_method.push({value: element.id_income_method, text: element.name });
      });
    }

  });
}

function OpenVoucher() {
  let me = this;
  let url1 = me.url_base + "income-bill-of-sale/"+ this.income.id_income;
  var ventana1 = window.open(url1, '_blank');
}

</script>
